import { render } from "./BankWithdrawSuccess.vue?vue&type=template&id=66524330"
import script from "./BankWithdrawSuccess.vue?vue&type=script&lang=js"
export * from "./BankWithdrawSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__